import { useMutation } from '@tanstack/react-query';
import { api } from '@app/utils/api';
import { errorHandler } from '@app/utils/errorHandler';
import { IMainIndicatorsFilter } from 'pages/Main/components/Filter';
import { BI_BASE_URL } from '@app/contstants/endpoints';
import { IBoeingLineAccounts } from '@entities/boeing/IBoeingLineAccounts';
import { buildDateParams } from '@app/utils/buildDateParams';

export const fetch = async (filters: IMainIndicatorsFilter): Promise<IBoeingLineAccounts[]> => {
  const params = buildDateParams(filters);

  const response = await api.get<{
    data: { reward: string; date: string }[];
  }>(`${BI_BASE_URL}/boeing/line/new/accounts`, {
    params: {
      manager_ids: filters.managers,
      region: filters.regions,
      tag: filters.tags,
      source: filters.sources,
      coins: filters.coins,
      ...params,
    },
  });

  const data = response.data ?? [];

  // @ts-ignore
  return data.map(
    (item: { date: string; new_hashrate: number; new_accounts: number; new_clients: number }) => ({
      date: item.date,
      hashrate: item.new_hashrate,
      accounts: item.new_accounts,
      clients: item.new_clients,
    })
  );
};

export const useBoeingLineNewAccounts = () => {
  const { mutateAsync, isError, isPending, isSuccess, error } = useMutation({
    mutationFn: fetch,
    onError: error => errorHandler(error),
  });

  return {
    fetch: mutateAsync,
    isError,
    isPending,
    isSuccess,
    error,
  };
};
